import { connectStateResults } from 'react-instantsearch-dom'
import React from 'react'

const HitCounter = connectStateResults(({
  searchResults, resultState, setHitsCount, hidden = false, firstsDailyRecipes,
}) => {
  let hitCount = searchResults && searchResults.nbHits > 0
    ? searchResults.nbHits
    : (resultState && resultState.nbHits ? resultState.nbHits : 0)

  const firstsDailyRecipesIds = firstsDailyRecipes && firstsDailyRecipes.length > 0 ? firstsDailyRecipes.map((hit) => hit.id) : []
  const hitsAlreadyInFirstResult = (searchResults && searchResults.hits)
    ? searchResults.hits.filter((hit) => firstsDailyRecipesIds.includes(hit.id))
    : (resultState && resultState.hits
      ? resultState.hits.filter((hit) => firstsDailyRecipesIds.includes(hit.id))
      : []
    )
  hitCount += (firstsDailyRecipes ? firstsDailyRecipes.length : 0) - hitsAlreadyInFirstResult.length
  console.log(hitsAlreadyInFirstResult)

  if (setHitsCount) {
    setHitsCount(hitCount)
  }

  return hitCount > 0 && !hidden ? (
    <div className="HitCount">
      {hitCount}
      {' '}
      recette
      {hitCount !== 1 ? 's' : ''}
    </div>
  ) : null
})

export default HitCounter
